import type { ComponentProps } from "react"
import { DropdownMenuTrigger as DropdownMenuTriggerBase } from "@/v2-ui/dropdownMenu/base/DropdownMenuBase"

export type DropdownMenuTriggerProps = ComponentProps<
  typeof DropdownMenuTriggerBase
>

function DropdownMenuTrigger(props: DropdownMenuTriggerProps) {
  const { asChild = true, ...dropdownMenuTriggerBase } = props
  return (
    <DropdownMenuTriggerBase asChild={asChild} {...dropdownMenuTriggerBase} />
  )
}

export default DropdownMenuTrigger
